import { Controller } from "@hotwired/stimulus"

// Guides users Players -> Format without splitting the shared convert form into real steps.
export default class extends Controller {
  static targets = ["nextButton", "generateButton"]

  connect() {
    this.boundSyncFooter = this.syncFooter.bind(this)
    this.element.addEventListener("shown.bs.tab", this.boundSyncFooter)
    this.syncFooter()
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.tab", this.boundSyncFooter)
  }

  showFormatTab(event) {
    event.preventDefault()

    const formatTabTrigger = this.element.querySelector("#format-tab")
    if (!formatTabTrigger || !window.bootstrap?.Tab) return

    window.bootstrap.Tab.getOrCreateInstance(formatTabTrigger).show()
  }

  syncFooter() {
    const formatTabIsActive = this.element.querySelector("#format-tab")?.classList.contains("active")

    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.classList.toggle("d-none", formatTabIsActive)
    }

    // Disable when hidden so Enter on the Players tab cannot submit the convert form.
    if (this.hasGenerateButtonTarget) {
      this.generateButtonTarget.classList.toggle("d-none", !formatTabIsActive)
      this.generateButtonTarget.disabled = !formatTabIsActive
    }
  }
}
